import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-photos-videos',
  templateUrl: './dialog-photos-videos.component.html',
  styleUrls: ['./dialog-photos-videos.component.scss']
})
export class DialogPhotosVideosComponent implements OnInit {
  selectedButton: string = 'photos';
  checked: boolean = false;
 
  ngOnInit(): void {
    console.log('PHOTOS-DATA', this.data);
  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogPhotosVideosComponent>) { }

  onClick() {
    this.dialogRef.close();
  }

  selectButton(e: string) {
    this.selectedButton = e;
  }


  toggleSelection() {
    this.checked = !this.checked;
  }



}
